import { Box, Button, Flex, Overlay } from "@mantine/core";
import { IconAlertTriangle, IconLogin } from "@tabler/icons";
import { signIn, useSession } from "next-auth/react";

const LoginOverlay = ({ message = "You Need to login first" }) => {
    const { data: session, status } = useSession();
    const usertype = !!session && !!session.info ? session.info.usertype : null;
    return (
        <Box>
            {!!!usertype && (
                <Overlay radius={"md"} opacity={1} color={"rgba(0, 0, 0, 0.5)"}>
                    <Flex h={"100%"} justify={"center"} align={"center"}>
                        <Button
                            color="red"
                            radius="xl"
                            leftIcon={<IconAlertTriangle />}
                            rightIcon={<IconLogin />}
                            onClick={() => {
                                signIn();
                            }}
                        >
                            {message}
                        </Button>
                    </Flex>
                </Overlay>
            )}
        </Box>
    );
};

export default LoginOverlay;
